import { render, staticRenderFns } from "./SubEight.vue?vue&type=template&id=256f6c5d&"
import script from "./SubEight.vue?vue&type=script&lang=js&"
export * from "./SubEight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports